@if (editLoader) {
<div class="stk-table-loader edit-segment-loader">
  <app-loader> </app-loader>
</div>
}
<div class="row-new">
  @if (currentTable==='ucmg-leader-view') {
  <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name">
    <span class="form-inline-new">
      <p class="lob-headers">Funding Segment</p>
    </span>
    <p>
      <span class="edit-defaults demographics-lob-default-name">{{ editUcmgData?.Funding_Segment }}</span>
    </p>
  </div>
  }
  <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name">
    <span class="form-inline-new">
      <p class="lob-headers">UCMG ID</p>
    </span>
    <p>
      <span class="edit-defaults demographics-lob-default-name">{{ editUcmgData?.UCMG_ID }}</span>
    </p>
  </div>
  <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name">
    <span class="form-inline-new">
      <p class="lob-headers">UCMG Name</p>
    </span>
    <p>
      <span class="edit-defaults demographics-lob-default-name">{{ editUcmgData?.UCMG_Name }}</span>
    </p>
  </div>
  <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name">
    <span class="form-inline-new">
      <p class="lob-headers">Total Forecast</p>
    </span>
    <p>
      <span class="edit-defaults demographics-lob-default-name">{{
        calculatedTotalForecast | currency: 'USD':'symbol':'1.0-0'
      }}</span>
    </p>
  </div>
  <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name">
    <span class="form-inline-new">
      <p class="lob-headers">Available Forecast</p>
    </span>
    <p>
      <span
        class="edit-defaults demographics-lob-default-name"
        [ngClass]="{
          positive: remainingAcap > 0,
          negative: remainingAcap < 0
        }"
      >
        {{ remainingAcap | currency: 'USD':'symbol':'1.0-0' }}</span
      >
    </p>
  </div>
  <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name">
    <span class="form-inline-new">
      <p class="lob-headers">Optum Tech Labor</p>
    </span>
    $
    <input
      class="lob-add-input lob-border"
      appDollarFormatAllowEmptySpace
      [(ngModel)]="optumTechLabour"
      (input)="updateAvailableAcap()"
      appIntegerOnly
      [allowNegative]="allowNegative"
      [disabled]="editUCMGUserRole !== 'Funding_Admin'"
    />
  </div>
  @if (currentTable==='ucmg-leader-view') {
  <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name">
    <span class="form-inline-new">
      <p class="lob-headers">Leader OT Allocation</p>
    </span>
    $
    <input
      class="lob-add-input lob-border"
      appDollarFormatAllowEmptySpace
      [(ngModel)]="leaderOTAllocation"
      (input)="updateAvailableAcap()"
      appIntegerOnly
      [allowNegative]="allowNegative"
    />
  </div>
  } @if (currentTable==='ucmg-segment-view') {
  <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name">
    <span class="form-inline-new">
      <p class="lob-headers">Advisory Services</p>
    </span>
    $
    <input
      class="lob-add-input lob-border"
      appDollarFormatAllowEmptySpace
      [(ngModel)]="advisoryService"
      (input)="updateAvailableAcap()"
      appIntegerOnly
      [allowNegative]="allowNegative"
      [disabled]="editUCMGUserRole !== 'Funding_Admin'"
    />
  </div>
  } @if (currentTable==='ucmg-segment-view') {
  <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name">
    <span class="form-inline-new">
      <p class="lob-headers">Business Labor</p>
    </span>
    $
    <input
      class="lob-add-input lob-border"
      appDollarFormatAllowEmptySpace
      [(ngModel)]="bussinessLabour"
      (input)="updateAvailableAcap()"
      appIntegerOnly
      [allowNegative]="allowNegative"
      [disabled]="editUCMGUserRole !== 'Funding_Admin'"
    />
  </div>
  } @if (currentTable==='ucmg-segment-view') {
  <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name">
    <span class="form-inline-new">
      <p class="lob-headers">Hardware/Software</p>
    </span>
    $
    <input
      class="lob-add-input lob-border"
      appDollarFormatAllowEmptySpace
      [(ngModel)]="hardwareSoftware"
      (input)="updateAvailableAcap()"
      appIntegerOnly
      [allowNegative]="allowNegative"
      [disabled]="editUCMGUserRole !== 'Funding_Admin'"
    />
  </div>
  } @if (currentTable==='ucmg-segment-view') {
  <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name mt-2">
    <span class="form-inline-new">
      <p class="lob-headers">Other Chargebacks</p>
    </span>
    $
    <input
      class="lob-add-input lob-border"
      appDollarFormatAllowEmptySpace
      [(ngModel)]="otherChargebacks"
      (input)="updateAvailableAcap()"
      appIntegerOnly
      [allowNegative]="allowNegative"
      [disabled]="editUCMGUserRole !== 'Funding_Admin'"
    />
  </div>
  } @if (currentTable==='ucmg-segment-view') {
  <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name mt-2">
    <span class="form-inline-new">
      <p class="lob-headers">Professional Fees</p>
    </span>
    $
    <input
      class="lob-add-input lob-border"
      appDollarFormatAllowEmptySpace
      [(ngModel)]="professionalFees"
      (input)="updateAvailableAcap()"
      appIntegerOnly
      [allowNegative]="allowNegative"
      [disabled]="editUCMGUserRole !== 'Funding_Admin'"
    />
  </div>
  }

  <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4 lob-edit-subLob-name mt-2">
    <span class="form-inline-new">
      <p class="lob-headers">Comments</p>
    </span>
    <textarea
      class="lob-add-input lob-border comments-textfield"
      [(ngModel)]="comments"
      maxlength="300"
      cols="100"
      rows="4"
      [disabled]="editUCMGUserRole !== 'Funding_Admin'"
    ></textarea>
    <p class="lob-text-right">Maximum 300 Characters</p>
  </div>

  @if (currentTable==='ucmg-segment-view') {
  <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name mt-3"></div>
  }

  <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name mt-3">
    <span class="form-inline-new">
      <p class="lob-headers">
        Portfolio Manager
        <!-- <b class="text-danger">*</b> -->
      </p>
    </span>

    <div class="lob-chip-field lob-border">
      <ng-container class="example-chip-list">
        @if (AddOwner.Portfolio_Manager) {
        <mat-form-field
          (click)="focusOnInput('inputAddPortfolioManager')"
          class="inline-form-edit lob-names-chip chip-fields"
          floatLabel="never"
        >
          <!-- show selected person -->
          <mat-chip-grid #chipListdel>
            @for (owner of AddOwner.Portfolio_Manager; track owner) {
            <mat-chip-row class="stk-mat-chip" (removed)="removeOwners(owner, 'Portfolio_Manager')">
              <span title="{{ owner.MSId }}" style="cursor: pointer;">
                {{ owner.displayName }}
              </span>
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
            }
          </mat-chip-grid>
          <!-- Type for person to search -->
          <input
            #inputAddPortfolioManager
            class="lob-chip-input"
            placeholder="Search by Name/Mail"
            [matAutocomplete]="auto"
            (keyup)="keyUpSearch($event, 'Portfolio_Manager')"
            [matChipInputFor]="chipListdel"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [disabled]="AddOwner.Portfolio_Manager.length === 1"
            [ngClass]="{ 'input-disabled': AddOwner.Portfolio_Manager.length === 1 }"
          />
          <!-- Selection Options -->
          <mat-autocomplete
            showPanel="true"
            class="lob-options-list"
            #auto="matAutocomplete"
            (optionSelected)="AddOwnerRole($event, 'Portfolio_Manager')"
          >
            @for (user of LDAPusersPM; track user) {
            <mat-option
              [disabled]="checkExistUser(user, 'Portfolio_Manager', 'Add')"
              title="{{ user.msid }}<{{ user.displayName }}>({{ user.mail }})"
              [value]="user"
            >
              {{ user.msid }}<{{ user.displayName }}>({{ user.mail }})
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        }
      </ng-container>
    </div>
  </div>

  <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 lob-edit-subLob-name mt-3">
    <span class="form-inline-new">
      <p class="lob-headers">
        UCMG Owner
        <!-- <b class="text-danger">*</b> -->
      </p></span
    >

    <div class="lob-chip-field lob-border">
      <ng-container class="example-chip-list">
        @if (AddOwner.UCMG_Owner) {
        <mat-form-field
          (click)="focusOnInput('inputAddUCMGOwner')"
          class="inline-form-edit lob-names-chip chip-fields"
          floatLabel="never"
        >
          <mat-chip-grid #chipListdel>
            @for (owner of AddOwner.UCMG_Owner; track owner) {
            <mat-chip-row class="stk-mat-chip" (removed)="removeOwners(owner, 'UCMG_Owner')">
              <span title="{{ owner.MSId }}" style="cursor: pointer;">
                {{ owner.displayName }}
              </span>
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
            }
          </mat-chip-grid>
          <input
            #inputAddUCMGOwner
            class="lob-chip-input"
            placeholder="Search by Name/Mail"
            [matAutocomplete]="auto"
            (keyup)="keyUpSearch($event, 'UCMG_Owner')"
            [matChipInputFor]="chipListdel"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [disabled]="AddOwner.UCMG_Owner.length === 1"
            [ngClass]="{ 'input-disabled': AddOwner.UCMG_Owner.length === 1 }"
          />
          <mat-autocomplete
            showPanel="true"
            class="lob-options-list"
            #auto="matAutocomplete"
            (optionSelected)="AddOwnerRole($event, 'UCMG_Owner')"
          >
            @for (user of LDAPusersUCMG; track user) {
            <mat-option
              [disabled]="checkExistUser(user, 'UCMG_Owner', 'Add')"
              title="{{ user.msid }}<{{ user.displayName }}>({{ user.mail }})"
              [value]="user"
            >
              {{ user.msid }}<{{ user.displayName }}>({{ user.mail }})
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        }
      </ng-container>
    </div>
  </div>
</div>
<div class="pull-right lob-add-apply-margin">
  <button
    mat-mdc-raised-button
    [disabled]="disableEditUcmg()"
    (click)="applyEdit()"
    class="add-apply m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size"
  >
    Apply
  </button>
</div>
